import { render } from "./AddonNutrition.vue?vue&type=template&id=64a465ac&scoped=true"
import script from "./AddonNutrition.vue?vue&type=script&lang=js"
export * from "./AddonNutrition.vue?vue&type=script&lang=js"

import "./AddonNutrition.vue?vue&type=style&index=0&id=64a465ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a465ac"]])

export default __exports__